import React, { useEffect } from "react"
import { Icon, Label, Table } from "semantic-ui-react"
import { useGetPaginatedEventHistory } from "../../../Hooks/FetchHooks/GetDataService/getOrganizationData/useGetPaginatedEventHistory"
import BifrostTable from "../../BifrostElementComponent/BifrostTable/BifrostTable"

const BifrostEventComponent = ({ chosenItem, chosenItemType }) => {
	const { data, isLoading, pagination, setPagination, getEventHistory } = useGetPaginatedEventHistory(chosenItem, chosenItemType)

	const eventHeaderColumns = React.useMemo(
		() => [
			{ name: "Timestamp (UTC)", key: "timestamp", type: "date" },
			{ name: "Action", key: "type", type: "string" },
			{ name: "Done By", key: "username", type: "string" },
			{ name: "Details", key: "details", type: "string" }
		],
		[]
	)

	const typeColors = {
		login_success: "green",
		login_failed: "red",
		otp_generated: "yellow",
		reboot: "grey",
		fw_upgrade: "grey",
		session_start: "blue",
		terms_accepted: "olive",
		session_end_by_admin: "purple", 
		subnet_mapping_created: "olive",
		subnet_mapping_deleted: "orange",
		direct_tunnel_enabled: "grey",
		direct_tunnel_disabled: "grey",
		subnet_mapping_reset_all: "grey",
		subnet_mapping_deleted_by_system: "orange",
		direct_tunnel_user_sign_up: "grey",
		direct_tunnel_user_peer_added: "grey",
		direct_tunnel_user_peer_login_expiration_enable: "grey",
		direct_tunnel_user_peer_login_expiration_disable: "grey",
		direct_tunnel_user_peer_login: "grey",
		direct_tunnel_user_peer_expires: "grey",
		direct_tunnel_user_peer_inactivity_expiration_enable: "grey",
		direct_tunnel_user_peer_inactivity_expiration_disable: "grey"

	}

	// From https://react.semantic-ui.com/elements/icon/

	const typeIcons = {
		login_success: "check",
		login_failed: "minus circle",
		otp_generated: "key",
		reboot: "redo",
		fw_upgrade: "arrow up",
		session_start: "play",
		terms_accepted: "paragraph",
		session_end_by_admin: "stop",
		subnet_mapping_created: "sitemap",
		subnet_mapping_deleted: "ban",
		direct_tunnel_enabled: "toggle on",
		direct_tunnel_disabled: "toggle off",
		subnet_mapping_reset_all: "undo",
		subnet_mapping_deleted_by_system: "ban",
		direct_tunnel_user_sign_up: "signup",
		direct_tunnel_user_peer_added: "add",
		direct_tunnel_user_peer_login_expiration_enable: "toggle on",
		direct_tunnel_user_peer_login_expiration_disable: "toggle off",
		direct_tunnel_user_peer_login: "ban",
		direct_tunnel_user_peer_expires: "hourglass end",
		direct_tunnel_user_peer_inactivity_expiration_enable: "toggle on",
		direct_tunnel_user_peer_inactivity_expiration_disable: "toggle off",

	}

	const typeText = {
		login_success: "Login Success",
		login_failed: "Login Failed",
		otp_generated: "OTP Generated",
		reboot: "Reboot",
		fw_upgrade: "Firmware Upgrade",
		session_start: "Session Start",
		terms_accepted: "Terms Accepted",
		session_end_by_admin: "Session Ended by Admin",
		subnet_mapping_created: "Subnet Mapping Created",
		subnet_mapping_deleted: "Subnet Mapping Deleted",
		direct_tunnel_enabled: "Direct Tunnel Enabled",
		direct_tunnel_disabled: "Direct Tunnel Disabled",
		subnet_mapping_reset_all: "Subnet Mapping Reset All",
		subnet_mapping_deleted_by_system: "Subnet Mapping Deleted by System",
		direct_tunnel_user_sign_up: "Direct Tunnel User Signup",
		direct_tunnel_user_peer_added: "Direct Tunnel User Peer Added",
		direct_tunnel_user_peer_login_expiration_enable: "Direct Tunnel Login Expiration Enabled",
		direct_tunnel_user_peer_login_expiration_disable: "Direct Tunnel Login Expiration Disabled",
		direct_tunnel_user_peer_login: "Direct Tunnel Peer Login",
		direct_tunnel_user_peer_expires: "Direct Tunnel Peer Login Expiration",
		direct_tunnel_user_peer_inactivity_expiration_enable: "Direct Tunnel Peer Inactivity Expiration Enabled",
		direct_tunnel_user_peer_inactivity_expiration_disable: "Direct Tunnel Peer Inactivity Expiration Disabled",		

	}

	const EventRow = ({ item }) => (
		<Table.Row key={item.timestamp}>
			<Table.Cell>{item.timestamp}</Table.Cell>
			<Table.Cell>
				<Label color={typeColors[item.type]}>
					<Icon name={typeIcons[item.type]} />
					{typeText[item.type]}
				</Label>
			</Table.Cell>
			<Table.Cell>{item.email}</Table.Cell>
			<Table.Cell>{item.details}</Table.Cell>
		</Table.Row>
	)

	const filterEvent = (event, filter) =>
		!filter || filter === ""
			? true
			: event.type.toLowerCase().includes(filter.toLowerCase()) ||
			  (event.username && event.username.toLowerCase().includes(filter.toLowerCase())) ||
			  event.timestamp.toLowerCase().includes(filter.toLowerCase()) ||
			  (event.details && event.details.toLowerCase().includes(filter.toLowerCase()))

	useEffect(() => {
		if (!data || !data.length) {
			getEventHistory(pagination)
		}
		// return () => setData([])
	}, [])

	return (
		<BifrostTable
			pageName="Events"
			loading={isLoading}
			data={data}
			columns={eventHeaderColumns}
			Row={EventRow}
			pagination={pagination}
			setPagination={setPagination}
			filterFunc={filterEvent}
			defaultSort={{ order: "descending", column: "timestamp" }}
			fetchData={getEventHistory}
		/>
	)
}

export default BifrostEventComponent
